import { render, staticRenderFns } from "./FullWidthSliderWithColumns.vue?vue&type=template&id=580c006e"
import script from "./FullWidthSliderWithColumns.vue?vue&type=script&lang=js"
export * from "./FullWidthSliderWithColumns.vue?vue&type=script&lang=js"
import style0 from "./FullWidthSliderWithColumns.vue?vue&type=style&index=0&id=580c006e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports